import { searchMyCanvases } from "../api/Canvas";
import { getMyAskedOppList } from "../api/Opportunity";

export interface UserCanvasFlags {
  hasSchoolCanvas: boolean;
  hasBusinessCanvas: boolean;
  hasPersonalCanvas: boolean;
  hasStudentCanvas: boolean;
  hasApplications: boolean;
}

/** User-facing "Dashboard" nav (/my-dashboard) is school-portfolio only. Direct URL access is unchanged. */
export function shouldShowUserDashboardNav(hasSchoolCanvas: boolean): boolean {
  return hasSchoolCanvas;
}

export function canvasFlagsFromList(list: any[]): UserCanvasFlags {
  return {
    hasSchoolCanvas: list.some((canvas) => canvas.type === "school"),
    hasBusinessCanvas: list.some((canvas) => canvas.type === "business"),
    hasPersonalCanvas: list.some(
      (canvas) => canvas.type === "professional" || canvas.type === "student"
    ),
    hasStudentCanvas: list.some((canvas) => canvas.type === "student"),
    hasApplications: false,
  };
}

export async function fetchUserCanvasFlags(): Promise<UserCanvasFlags> {
  const res = await searchMyCanvases("", "all");
  const flags = canvasFlagsFromList(res?.list || []);
  let hasApplications = false;
  if (!flags.hasSchoolCanvas) {
    try {
      const applications = await getMyAskedOppList();
      hasApplications = Array.isArray(applications) && applications.length > 0;
    } catch {
      hasApplications = false;
    }
  }
  return { ...flags, hasApplications };
}

export function shouldShowPlacementReportingNav(hasSchoolCanvas: boolean): boolean {
  return hasSchoolCanvas;
}

/** Applied opportunities nav when user has applied and does not use the school dashboard. */
export function shouldShowMyApplicationsNav(
  hasSchoolCanvas: boolean,
  hasApplications: boolean
): boolean {
  return !hasSchoolCanvas && hasApplications;
}

export const MY_BUSINESS_EXTERNAL_PATH = "__external_my_business__";
export const HOME_EXTERNAL_PATH = "__external_home__";
export const CONNECT_EXTERNAL_PATH = "__external_connect__";
export const PLACEMENT_REPORTING_EXTERNAL_PATH = "__external_placement_reporting__";
export const MY_APPLICATIONS_EXTERNAL_PATH = "__external_my_applications__";
/** Default Community nav destination (main feed), opens in a new tab from app chrome. */
export const COMMUNITY_NAV_URL =
  "https://connect.beautista.com/spaces/16283746/feed";

export function homeMenuItem() {
  return {
    name: "Home",
    path: HOME_EXTERNAL_PATH,
    externalHref: `${process.env.REACT_APP_NEXT_URL}/home`,
  };
}

export function myBusinessMenuItem() {
  return {
    name: "My Business",
    path: MY_BUSINESS_EXTERNAL_PATH,
    externalHref: `${process.env.REACT_APP_NEXT_URL}/business`,
  };
}

export function myApplicationsMenuItem() {
  return {
    name: "My Applications",
    path: MY_APPLICATIONS_EXTERNAL_PATH,
    externalHref: `${process.env.REACT_APP_NEXT_URL}/applications`,
  };
}

export function placementReportingMenuItem() {
  return {
    name: "Placement Reporting",
    path: PLACEMENT_REPORTING_EXTERNAL_PATH,
    externalHref: `${process.env.REACT_APP_NEXT_URL}/school/placement`,
  };
}

export function connectMenuItem() {
  return {
    name: "Community",
    path: CONNECT_EXTERNAL_PATH,
    externalHref: COMMUNITY_NAV_URL,
    openInNewTab: true,
  };
}
